// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-migrate-to-workbook-dialog-entries-group__header {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.dl-migrate-to-workbook-dialog-entries-group__chevron-icon {
  transition: transform 0.3s linear;
}
.dl-migrate-to-workbook-dialog-entries-group__chevron-icon_open {
  transform: rotate(90deg);
}
.dl-migrate-to-workbook-dialog-entries-group__title {
  margin-left: 12px;
}
.dl-migrate-to-workbook-dialog-entries-group__count {
  margin-left: 12px;
  color: var(--g-color-text-secondary);
}
.dl-migrate-to-workbook-dialog-entries-group__list {
  margin-top: 6px;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
.dl-migrate-to-workbook-dialog-entries-group__list_open {
  max-height: 5000px;
  opacity: 1;
}
.dl-migrate-to-workbook-dialog-entries-group__item {
  margin-top: 6px;
}
.dl-migrate-to-workbook-dialog-entries-group__item:first-child {
  margin-top: 0;
}
.dl-migrate-to-workbook-dialog-entries-group__show-more {
  margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MigrateToWorkbookDialog/components/EntriesGroup/EntriesGroup.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAAR;AAGI;EACI,iCAAA;AADR;AAGQ;EACI,wBAAA;AADZ;AAKI;EACI,iBAAA;AAHR;AAMI;EACI,iBAAA;EACA,oCAAA;AAJR;AAOI;EACI,eAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gCAAA;AALR;AAOQ;EACI,kBAAA;EACA,UAAA;AALZ;AASI;EACI,eAAA;AAPR;AASQ;EACI,aAAA;AAPZ;AAWI;EACI,eAAA;AATR","sourcesContent":[".dl-migrate-to-workbook-dialog-entries-group__header {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.dl-migrate-to-workbook-dialog-entries-group__chevron-icon {\n  transition: transform 0.3s linear;\n}\n.dl-migrate-to-workbook-dialog-entries-group__chevron-icon_open {\n  transform: rotate(90deg);\n}\n.dl-migrate-to-workbook-dialog-entries-group__title {\n  margin-left: 12px;\n}\n.dl-migrate-to-workbook-dialog-entries-group__count {\n  margin-left: 12px;\n  color: var(--g-color-text-secondary);\n}\n.dl-migrate-to-workbook-dialog-entries-group__list {\n  margin-top: 6px;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: all 0.3s ease-in-out;\n}\n.dl-migrate-to-workbook-dialog-entries-group__list_open {\n  max-height: 5000px;\n  opacity: 1;\n}\n.dl-migrate-to-workbook-dialog-entries-group__item {\n  margin-top: 6px;\n}\n.dl-migrate-to-workbook-dialog-entries-group__item:first-child {\n  margin-top: 0;\n}\n.dl-migrate-to-workbook-dialog-entries-group__show-more {\n  margin-top: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
